import { useEffect, useRef, useState } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import {
  TabulatorFull as Tabulator,
  ColumnComponent,
  CellComponent,
} from "tabulator-tables";
import Select from "react-select";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import { IVisaoGeralModel } from "../modules/services/core/_models";
import { RequestMethod } from "../modules/services/core/_enums";
import moment from "moment";
import { useAuth } from "../modules/auth";
import { accessSync } from "fs";

function isEmpty(str: string) {
  return !str || str.length === 0;
}

interface Organization {
  OrganizationId: number;
  OrganizationName: string;
  Idcorporacao: number;
  CorporationName: string;
}

interface Corporation {
  id: number;
  name: string;
}

interface TableFilter {
  field: string;
  value: any;
}

const MenuAlertTestPage: React.FC = () => {
  const { auth } = useAuth();
  const user = auth?.User;
  const emailUsuario = user?.Email;
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  console.log("Email do usuário:", emailUsuario); // Debug do email

  const [userId, setUserId] = useState<string>("");
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const httpClient = useHttpClient();
  const configTableRef = useRef<HTMLDivElement>(null);
  const tableRef = useRef<HTMLDivElement>(null);
  const configTableRefInstance = useRef<any>(null);
  const mainTableRef = useRef<any>(null);
  let [visaoGeral, setVisaoGeral] = useState<IVisaoGeralModel[]>([]);
  const [filteredVisao, setFilteredVisao] = useState<IVisaoGeralModel[]>([]);
  const [filtros, setFiltros] = useState<any>({});
  let [filteredRowCount, setFilteredRowCount] = useState<number>(0);
  const [selectedOrganizations, setSelectedOrganizations] = useState<string[]>(
    []
  );
  const [initialOrganizations, setInitialOrganizations] = useState<string[]>(
    []
  );
  const [availableOrganizations, setAvailableOrganizations] = useState<
    Organization[]
  >([]);
  const [availableCorporations, setAvailableCorporations] = useState<Corporation[]>([]);
  const [selectedCorporation, setSelectedCorporation] = useState<number | null>(null);

  // Novo estado para armazenar os filtros ativos
  const [activeFilters, setActiveFilters] = useState<Record<string, any>>({});

  // Adicione este estado no início do componente, junto com os outros estados
  const [urlFiltersApplied, setUrlFiltersApplied] = useState(false);

  // Função para salvar os filtros no localStorage
  const saveFiltersToStorage = (filters: Record<string, any>) => {
    localStorage.setItem('menuAlertTestPageFilters', JSON.stringify(filters));
  };

  // Função para carregar os filtros do localStorage
  const loadFiltersFromStorage = () => {
    const savedFilters = localStorage.getItem('menuAlertTestPageFilters');
    return savedFilters ? JSON.parse(savedFilters) : null;
  };

  // Função para verificar se é um refresh da página
  const isPageRefresh = () => {
    return !window.performance
      || window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD
      || window.performance.getEntriesByType('navigation').some((nav: any) => nav.type === 'reload');
  };

  // Função para aplicar os filtros salvos na tabela
  const applyStoredFilters = () => {
    if (!mainTableRef.current || isPageRefresh()) return;

    const savedFilters = loadFiltersFromStorage();
    if (!savedFilters) return;

    const columns = mainTableRef.current.getColumns();

    columns.forEach((column: ColumnComponent) => {
      const field = column.getField();
      if (savedFilters[field]) {
        column.setHeaderFilterValue(savedFilters[field]);
      }
    });

    // Se havia organizações selecionadas, reaplica o filtro
    if (savedFilters.selectedOrganizations) {
      setSelectedOrganizations(savedFilters.selectedOrganizations);
      aplicarFiltroOrganizacoes(savedFilters.selectedOrganizations);
    }
  };

  // Função para limpar os filtros salvos
  const clearStoredFilters = () => {
    localStorage.removeItem('menuAlertTestPageFilters');
    setSelectedOrganizations([]);
    setActiveFilters({});
    if (mainTableRef.current) {
      mainTableRef.current.clearHeaderFilter();
      mainTableRef.current.setData(visaoGeral);
    }
  };

  // Efeito para limpar filtros no refresh
  useEffect(() => {
    if (isPageRefresh()) {
      clearStoredFilters();
      obterVisaoGeral();
    }
  }, []);

  // Modificar o useEffect principal
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeData = async () => {
      if (!emailUsuario || isInitialized) return;

      try {
        const id = await fetchUserId();
        if (id) {
          await fetchUserOrganizations(id);
          setIsInitialized(true);
        }
      } catch (error) {
        console.error("Erro ao inicializar dados do usuário:", error);
      }
    };

    initializeData();
  }, [emailUsuario, isInitialized]);

  // Novo useEffect para aplicar filtros da URL após a inicialização
  useEffect(() => {
    if (isInitialized && mainTableRef.current && !urlFiltersApplied) {
      const params = new URLSearchParams(window.location.search);
      const type = params.get('type');
      const situacao = params.get('situacao');
      const orgParam = params.get('org');

      console.log("Aplicando filtros da URL:", { type, situacao, orgParam });

      // Aplicar filtro de organização
      if (orgParam) {
        const orgsFromUrl = orgParam.split(',').map(org => org.trim());
        const validOrgs = orgsFromUrl.filter(org =>
          availableOrganizations.some(availOrg =>
            availOrg.OrganizationName.toLowerCase() === org.toLowerCase()
          )
        );

        if (validOrgs.length > 0) {
          setSelectedOrganizations(validOrgs);
          obterVisaoGeral(validOrgs);
        }
      }

      // Aplicar filtro de tipo (Gateway/Ativo)
      if (type) {
        const origemColumn = mainTableRef.current.getColumn("Origem");
        if (origemColumn) {
          const origemValue = type === "Gateway" ? "gateway" : type;
          console.log("Aplicando filtro de Origem:", origemValue);
          origemColumn.setHeaderFilterValue([origemValue]);
        }
      }

      // Aplicar filtro de situação (0/1)
      if (situacao !== null) {
        const situacaoColumn = mainTableRef.current.getColumn("Situacao");
        if (situacaoColumn) {
          situacaoColumn.setHeaderFilterValue(situacao);
        }
      }

      setUrlFiltersApplied(true);
    }
  }, [isInitialized, availableOrganizations, urlFiltersApplied]);

  // Adicionar um novo useEffect para reagir às mudanças em availableOrganizations
  useEffect(() => {
    if (availableOrganizations.length > 0 && visaoGeral.length > 0) {
      console.log("Organizações disponíveis atualizadas, refiltrando dados");
      const organizacoesPermitidas = availableOrganizations.map(org => org.OrganizationName);
      const dadosFiltrados = visaoGeral.filter((item: IVisaoGeralModel) =>
        organizacoesPermitidas.includes(item.Organization)
      );
      setFilteredVisao(dadosFiltrados);
    }
  }, [availableOrganizations]);

  // Nova função para buscar o ID do usuário pelo email
  const fetchUserId = async () => {
    if (!emailUsuario) {
      console.log("Email do usuário não disponível");
      return;
    }

    try {
      const url = `${backendUrl}/api/User/ByEmail/${encodeURIComponent(
        emailUsuario
      )}`;
      console.log("Fazendo requisição para:", url);

      const response = await fetch(url);
      console.log("Status da resposta:", response.status);

      if (response.ok) {
        const userId = await response.json();
        console.log("Dados do usuário:", userId);
        setUserId(userId.toString()); // Convertendo para string pois o ID vem como número
        return userId.toString(); // Retornando como string para manter consistência
      } else {
        const errorText = await response.text();
        console.error(
          "Erro ao buscar ID do usuário. Status:",
          response.status,
          "Texto:",
          errorText
        );
      }
    } catch (error) {
      console.error("Erro ao buscar ID do usuário:", error);
    }
  };

  // Modificar a função fetchUserOrganizations
  const fetchUserOrganizations = async (id: string) => {
    if (!id) {
      console.log("ID do usuário não disponível");
      return;
    }

    try {
      const url = `${backendUrl}/api/UserOrganization/CorpByUser?userId=${id}`;
      console.log("Fazendo requisição para:", url);

      const response = await fetch(url);
      console.log("Status da resposta:", response.status);

      if (response.ok) {
        const data = await response.json();
        console.log("Organizações recebidas:", data);

        if (Array.isArray(data) && data.length > 0) {
          // Criar um Map para armazenar corporações únicas usando uma chave composta
          const corporationsMap = new Map();

          // Primeiro passo: adicionar cada corporação ao Map usando uma chave composta
          data.forEach(org => {
            const key = `${org.Idcorporacao}-${org.CorporationName}`;
            if (!corporationsMap.has(key)) {
              corporationsMap.set(key, {
                id: org.Idcorporacao,
                name: org.CorporationName
              });
            }
          });

          // Converter o Map para array de corporações únicas
          const corporations = Array.from(corporationsMap.values());
          setAvailableCorporations(corporations);
          setAvailableOrganizations(data);

          // Definir organizações iniciais
          const orgNames = data.map((org: Organization) => org.OrganizationName);
          setInitialOrganizations(orgNames);

          // Verificar se existe organização na URL
          const params = new URLSearchParams(window.location.search);
          const orgParam = params.get('org');

          if (orgParam) {
            // Se tem organização na URL, usa ela(s)
            const orgsFromUrl = orgParam.split(',').map(org => org.trim());
            // Filtra para garantir que só use organizações que o usuário tem acesso
            const validOrgs = orgsFromUrl.filter(org => orgNames.includes(org));

            if (validOrgs.length > 0) {
              console.log("Usando organizações da URL:", validOrgs);
              setSelectedOrganizations(validOrgs);
              await obterVisaoGeral(validOrgs);
              return validOrgs;
            }
          }

          // Se não tem org na URL ou as orgs da URL são inválidas, usa a primeira
          const primeiraOrganizacao = [orgNames[0]];
          console.log("Selecionando primeira organização:", primeiraOrganizacao);
          setSelectedOrganizations(primeiraOrganizacao);
          await obterVisaoGeral(primeiraOrganizacao);
          return primeiraOrganizacao;
        }
      }
    } catch (error) {
      console.error("Erro ao buscar organizações:", error);
    }
  };

  async function exportTableToExcel() {
    const tableData = mainTableRef.current.getData();
    const filteredData = mainTableRef.current.getData("active");
    const visibleColumns = mainTableRef.current
      .getColumns()
      .filter((col: ColumnComponent) => col.isVisible());

    const columnOrder: string[] = visibleColumns.map((col: ColumnComponent) =>
      col.getField()
    );

    const orderedData = filteredData.map((row: Record<string, any>) => {
      const orderedRow: Record<string, any> = {};

      columnOrder.forEach((field) => {
        if (row.hasOwnProperty(field)) {
          orderedRow[field] = row[field] ?? "";
        }
      });
      return orderedRow;
    });

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const endpoint = `${backendUrl}/Report/Excel`;
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(orderedData),
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "VisãoGeral.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        console.log("Arquivo Excel baixado com sucesso!");
      } else {
        console.error("Erro ao baixar o arquivo Excel:", response.statusText);
      }
    } catch (error) {
      console.error("Erro ao fazer o POST:", error);
    }
  }

  // Função auxiliar para resetar filtros
  const resetHeaderFilters = () => {
    const columns = mainTableRef.current.getColumns();
    columns.forEach((column: any) => {
      const headerFilter = column.getHeaderFilterValue();
      if (headerFilter !== null && headerFilter !== undefined) {
        try {
          column.setHeaderFilterValue('');
        } catch (e) {
          console.error(`Erro ao limpar filtro da coluna ${column.getField()}:`, e);
        }
      }
    });
  };

  // Função para limpar todos os filtros
  const limparFiltros = () => {
    if (mainTableRef.current) {
      try {
        // Limpar seleção de organizações
        setSelectedOrganizations([]);
        setSelectedCorporation(null);

        // Usar a função segura para limpar os filtros
        resetHeaderFilters();

        // Limpar filtros salvos
        clearStoredFilters();

        // Limpar os dados da tabela já que não há organizações selecionadas
        setVisaoGeral([]);
        mainTableRef.current.setData([]);

        // Forçar atualização visual da tabela
        mainTableRef.current.redraw(true);

        // Atualizar o footer
        const footerEl = document.getElementById("footer");
        if (footerEl) {
          footerEl.innerHTML = `0 linhas retornadas (linhas filtradas: 0)`;
        }
      } catch (error) {
        console.error("Erro ao limpar filtros:", error);
      }
    }
  };

  const createInputFilterEditor =
    (field: keyof IVisaoGeralModel) =>
      (cell: any, onRendered: any, success: any, cancel: any) => {
        const container = document.createElement("div");
        container.style.position = "relative"; // Garante que a lista seja posicionada corretamente

        // Input para digitar o filtro
        const input = document.createElement("input");
        input.setAttribute("type", "text");
        input.setAttribute("placeholder", "Buscar...");
        input.classList.add("filter-input"); // Adiciona a classe do input

        // Lista de sugestões
        const suggestionList = document.createElement("div");
        suggestionList.classList.add("suggestion-list"); // Adiciona a classe da lista
        suggestionList.style.position = "absolute";
        suggestionList.style.top = "100%";
        suggestionList.style.left = "0";
        suggestionList.style.right = "0";
        suggestionList.style.zIndex = "1000"; // Aumente o z-index
        suggestionList.style.maxHeight = "200px";
        suggestionList.style.overflowY = "auto";
        suggestionList.style.display = "none";

        // Adiciona a lista de sugestões ao body
        document.body.appendChild(suggestionList);

        // Função para atualizar a lista de sugestões
        const updateSuggestions = (filterText: string) => {
          const uniqueValues = Array.from(
            new Set(visaoGeral.map((item) => item[field]))
          );
          const filteredValues = uniqueValues.filter((value) =>
            value?.toString().toLowerCase().includes(filterText.toLowerCase())
          );

          suggestionList.innerHTML = ""; // Limpa a lista atual
          filteredValues.forEach((value) => {
            const suggestionItem = document.createElement("div");
            suggestionItem.textContent = value;
            suggestionItem.classList.add("suggestion-item"); // Adiciona a classe do item
            suggestionItem.addEventListener("click", () => {
              input.value = value; // Preenche o input com o valor selecionado
              suggestionList.style.display = "none"; // Oculta a lista
              success(value); // Aplica o filtro
            });
            suggestionList.appendChild(suggestionItem);
          });

          if (filteredValues.length > 0) {
            suggestionList.style.display = "block"; // Mostra a lista
          } else {
            suggestionList.style.display = "none"; // Oculta a lista se não houver sugestões
          }
        };

        // Evento de digitação no input
        input.addEventListener("input", (e) => {
          const filterText = (e.target as HTMLInputElement).value;
          updateSuggestions(filterText);

          // Atualiza a posição da lista de sugestões
          const rect = input.getBoundingClientRect();
          suggestionList.style.top = `${rect.bottom + window.scrollY}px`;
          suggestionList.style.left = `${rect.left + window.scrollX}px`;
          suggestionList.style.width = `${rect.width}px`;
        });

        // Evento de foco no input
        input.addEventListener("focus", () => {
          updateSuggestions(input.value);

          // Atualiza a posição da lista de sugestões
          const rect = input.getBoundingClientRect();
          suggestionList.style.top = `${rect.bottom + window.scrollY}px`;
          suggestionList.style.left = `${rect.left + window.scrollX}px`;
          suggestionList.style.width = `${rect.width}px`;
        });

        // Evento de clique fora do input (para ocultar a lista)
        document.addEventListener("click", (e) => {
          if (!container.contains(e.target as Node)) {
            suggestionList.style.display = "none";
          }
        });

        container.appendChild(input);

        return container;
      };
  const createInputFilterFunction =
    (field: string) => (headerValue: string, rowValue: string) => {
      if (!headerValue) return true; // Se não houver filtro, mostra todas as linhas
      return rowValue
        ?.toString()
        .toLowerCase()
        .includes(headerValue.toLowerCase());
    };

  const aplicarFiltroOrganizacoes = async (Organizations: string[]) => {
    if (!urlFiltersApplied) {
      // Não executar se ainda estiver aplicando filtros da URL
      return;
    }

    if (Organizations.length > 0) {
      await obterVisaoGeral(Organizations);
      console.log(Organizations);
    } else {
      await obterVisaoGeral();
    }
  };
  const dataSetNamePBI = getDataSetNamePBI();
  const obterVisaoGeral = async (orgs?: string[]) => {
    try {
      // Se não foram passadas organizações específicas, não usa fallback
      if (!orgs || orgs.length === 0) {
        console.log("Nenhuma organização selecionada");
        setVisaoGeral([]);
        setFilteredVisao([]);
        return;
      }

      const endpoint = "/Gerenciamento/PowerBI/ObterVisaoGeralByOrg";
      const queryParams = new URLSearchParams();

      if (dataSetNamePBI) {
        queryParams.append("datasetName", dataSetNamePBI);
      }

      // Adiciona as organizações selecionadas aos parâmetros
      orgs.forEach((org) => {
        queryParams.append("org", org);
      });

      const queryString = queryParams.toString();
      const fullUrl = `${endpoint}?${queryString}`;

      console.log("Requisitando dados do endpoint:", fullUrl);
      console.log("Organizações sendo usadas:", orgs);

      const response = await httpClient.request({
        method: RequestMethod.GET,
        endpoint: fullUrl,
      });

      if (response.success && response.payload) {
        console.log("Total de dados recebidos:", response.payload.length);
        setVisaoGeral(response.payload);
        setFilteredVisao(response.payload);
      }
    } catch (error) {
      console.error("Erro ao obter visão geral:", error);
    }
  };

  const loadConfigTable = () => {
    const cols = mainTableRef.current
      .getColumns()
      .map((col: ColumnComponent, index: number) => ({
        id: index + 1,
        title: col.getDefinition().title || col.getField(),
        field: col.getField(),
        visible: col.isVisible(),
      }));

    if (configTableRef.current) {
      if (configTableRefInstance.current) {
        configTableRefInstance.current.destroy();
      }

      configTableRefInstance.current = new Tabulator(configTableRef.current, {
        data: cols,
        layout: "fitDataFill",
        movableRows: true,
        headerVisible: false,
        rowFormatter: function (row) {
          console.log(row.getData());
          var data = row.getData();
          if (data.id === 1 || data.id === 2 || data.id === 3) {
            row.getElement().style.display = "none";
          }
        },
        columns: [
          {
            title: "Mover",
            formatter: "handle",
            headerSort: false,
            width: 30,
            minWidth: 30,
          },
          {
            title: "Coluna",
            field: "title",
            formatter: (cell) => ` ${cell.getValue()}`,
          },
          {
            title: "Visível",
            field: "visible",
            formatter: "tickCross",
            editor: true,
          },
        ],
      });
    }
  };
  const deltaTime = (minutes: number) => {
    const MINUTES_IN_HOUR = 60;
    const HOURS_IN_DAY = 24;
    const DAYS_IN_MONTH = 30;

    const months = Math.floor(
      minutes / (MINUTES_IN_HOUR * HOURS_IN_DAY * DAYS_IN_MONTH)
    );
    minutes %= MINUTES_IN_HOUR * HOURS_IN_DAY * DAYS_IN_MONTH;

    const days = Math.floor(minutes / (MINUTES_IN_HOUR * HOURS_IN_DAY));
    minutes %= MINUTES_IN_HOUR * HOURS_IN_DAY;

    const hours = Math.floor(minutes / MINUTES_IN_HOUR);
    const remainingMinutes = minutes % MINUTES_IN_HOUR;

    const M = months ? `${months} M, ` : "";
    const D = days ? `${days} d, ` : "";
    const H = hours ? `${hours} h e ` : "";
    const I = `${remainingMinutes} min`;

    return `${M}${D}${H}${I}`;
  };

  const durationFilterEditor = (
    cell: any,
    onRendered: any,
    success: any,
    cancel: any
  ) => {
    const container = document.createElement("span");

    const start = document.createElement("input");
    start.setAttribute("type", "number");
    start.setAttribute("placeholder", "Min");
    start.style.padding = "4px";
    start.style.width = "32%";

    const end = start.cloneNode() as HTMLInputElement;
    end.setAttribute("placeholder", "Max");

    const lista = document.createElement("select");
    lista.style.width = "32%";
    lista.style.padding = "2px";

    ["Minutos", "Horas", "Dias", "Meses"].forEach((opt) => {
      const option = document.createElement("option");
      option.value = opt.toLowerCase();
      option.text = opt;
      lista.appendChild(option);
    });

    const buildValues = () => {
      success({
        start: start.value,
        end: end.value,
        unit: lista.value,
      });
    };

    [start, end, lista].forEach((el) => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
    });

    container.appendChild(start);
    container.appendChild(end);
    container.appendChild(lista);

    return container;
  };
  const interationFilterEditor = (
    cell: any,
    onRendered: any,
    success: any,
    cancel: any
  ) => {
    const container = document.createElement("span");

    const start = document.createElement("input");
    start.setAttribute("type", "number");
    start.setAttribute("placeholder", "Min");
    start.style.padding = "4px";
    start.style.width = "50%";

    const end = document.createElement("input");
    end.setAttribute("type", "number");
    end.setAttribute("placeholder", "Max");
    end.style.padding = "4px";
    end.style.width = "50%";

    const buildValues = () => {
      success({
        number1: start.value,
        number2: end.value,
      });
    };

    [start, end].forEach((el) => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
    });

    container.appendChild(start);
    container.appendChild(end);

    return container;
  };

  const interationFilterFunction = (
    headerValue: { number1: string; number2: string },
    rowValue: string
  ) => {
    if (!headerValue || (!headerValue.number1 && !headerValue.number2))
      return true;
    if (!rowValue) return false;

    const rowData = Number(rowValue);

    const number1 = headerValue.number1
      ? parseFloat(headerValue.number1)
      : null;
    const number2 = headerValue.number2
      ? parseFloat(headerValue.number2)
      : null;

    if (number1 === null) {
      if (number2 === null) return true;
      return rowData <= number2;
    } else {
      if (number2 === null) return rowData >= number1;
      return rowData >= number1 && rowData <= number2;
    }
  };

  // Editor personalizado para filtro de data
  const dateEditor = (
    cell: any,
    onRendered: any,
    success: any,
    cancel: any
  ) => {
    const container = document.createElement("span");

    // Criar inputs de data
    const date2 = document.createElement("input");
    date2.setAttribute("type", "date");
    date2.style.padding = "3px";
    date2.style.width = "50%";
    date2.style.fontSize = "12px";
    date2.style.boxSizing = "border-box";

    const date1 = date2.cloneNode() as HTMLInputElement;

    // Configurar datas iniciais
    const hoje = new Date();
    date2.value = hoje.toISOString().split("T")[0];

    const dataAnterior = new Date();
    dataAnterior.setFullYear(dataAnterior.getFullYear() - 1);
    date1.value = dataAnterior.toISOString().split("T")[0];

    const buildValues = () => {
      success({
        date1: date1.value,
        date2: date2.value,
      });
    };

    const keypress = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        buildValues();
      }
      if (e.key === "Escape") {
        cancel();
      }
    };

    // Adicionar event listeners
    [date1, date2].forEach((el) => {
      el.addEventListener("change", buildValues);
      el.addEventListener("blur", buildValues);
      el.addEventListener("keydown", keypress);
    });

    container.appendChild(date1);
    container.appendChild(date2);

    return container;
  };

  // Função de filtro para datas
  const dateFilterFunction = (headerValue: any, rowValue: any) => {
    // Se não há filtro definido, mostra todos os registros
    if (!headerValue || (!headerValue.date1 && !headerValue.date2)) return true;

    // Se o valor da linha é vazio/nulo, não mostra
    if (!rowValue) return false;

    // Função para normalizar qualquer formato de data para Date
    const normalizeDate = (dateValue: string | Date) => {
      // Se já é um objeto Date, retorna diretamente
      if (dateValue instanceof Date) return dateValue;

      // Tenta parsear formato DD/MM/YYYY HH:mm:ss
      const dateTimeMatch = String(dateValue).match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
      if (dateTimeMatch) {
        const [_, day, month, year, hours, minutes, seconds] = dateTimeMatch;
        return new Date(
          parseInt(year),
          parseInt(month) - 1,
          parseInt(day),
          parseInt(hours),
          parseInt(minutes),
          parseInt(seconds)
        );
      }

      // Tenta parsear como ISO
      const date = new Date(dateValue);
      return isNaN(date.getTime()) ? null : date;
    };

    // Normaliza a data da linha
    const rowDate = normalizeDate(rowValue);
    if (!rowDate) return false;

    // Normaliza as datas do filtro
    const startDate = headerValue.date1 ? new Date(headerValue.date1) : null;
    const endDate = headerValue.date2 ? new Date(headerValue.date2) : null;


    // Ajusta o endDate para incluir o dia inteiro pois o filtro funciona com base no intervalo entre as datas selecionadas.
    if (endDate) {
      endDate.setDate(endDate.getDate() + 1);
    }

    // Se não há datas no filtro, mostra tudo
    if (!startDate && !endDate) return true;

    // Ajusta o range do filtro
    const startOfDay = startDate ? new Date(startDate) : null;
    const endOfDay = endDate ? new Date(endDate) : null;

    if (startOfDay) startOfDay.setHours(0, 0, 0, 0);
    if (endOfDay) endOfDay.setHours(23, 59, 59, 999);

    // Caso 1: Mesma data em ambos os campos (filtro para um único dia)
    if (startDate && endDate && startDate.toDateString() === endDate.toDateString()) {
      return rowDate >= startOfDay! && rowDate <= endOfDay!;
    }

    // Caso 2: Apenas data inicial definida
    if (startDate && !endDate) {
      return rowDate >= startOfDay!;
    }

    // Caso 3: Apenas data final definida
    if (!startDate && endDate) {
      return rowDate <= endOfDay!;
    }

    // Caso 4: Intervalo de datas definido
    if (startDate && endDate) {
      return rowDate >= startOfDay! && rowDate <= endOfDay!;
    }

    return true;
  };

  useEffect(() => {
    if (tableRef.current) {
      if (mainTableRef.current) {
        mainTableRef.current.destroy();
      }
      console.log("Visao Geral:", visaoGeral);
      // Se for refresh, não aplica os filtros salvos
      const shouldApplyFilters = !isPageRefresh();

      mainTableRef.current = new Tabulator(tableRef.current, {
        persistence: shouldApplyFilters ? true : undefined,
        persistenceMode: "local",
        data: visaoGeral,
        height: 650,
        layout: "fitData",
        movableColumns: true,
        resizableColumnFit: true,
        columnHeaderVertAlign: "top",
        footerElement: `<div id="footer">${visaoGeral.length} linhas retornadas (linhas filtradas: 0)</div>`,

        columns: [
          {
            title: "",
            field: "Situacao",
            frozen: true,
            formatter: function (cell, formatterParams) {
              var data = cell.getData();

              if (data.Situacao === 1) {
                return '<i class="ui large green check icon" style="padding: 2px;" title="Fechado"></i>';
              } else {
                return '<i class="ui large grey clock icon" style="padding: 2px;" title="Aberto"></i>';
              }
            },
            hozAlign: "center",
            resizable: false,
            tooltip: "Alerta aberto ou fechado",
            width: 110,
            headerFilter: "list",
            headerSortStartingDir: "asc",
            headerSort: true, // Permite ordenação pelo cabeçalho
            sorter: function (a, b,) {
              // Ordena os valores numéricos (0 = Aberto, 1 = Fechado)
              return a - b;
            },
            headerFilterParams: {
              values: {
                "": "Todos",          // Valor padrão para mostrar todos
                "0": "Abertos",       // Situacao = 0
                "1": "Fechados"       // Situacao = 1
              },
              sortValuesList: "asc"
            },
            headerFilterFunc: function (headerValue, rowValue, rowData, filterParams) {
              // rowValue é o valor de Situacao (0 ou 1)
              if (headerValue === "0") {
                return rowValue === 0 || rowValue === "0";
              }
              if (headerValue === "1") {
                return rowValue === 1 || rowValue === "1";
              }
              return true; // Mostra todos se não houver filtro selecionado
            }
          },
          {
            field: "origemIcone",
            title: "",
            formatter: function (cell, f) {
              var data = cell.getData();
              var origem = data.Origem;
              var local = data.Local;

              if (origem === "Gateway") {
                if (local && local.includes("Frota")) {
                  return `<img src="https://portal.taggen.net/assets/imagens/green-car-48px.png" alt="Frota Icon" style="width: 24px;">`;
                } else {
                  return `<img src="https://portal.taggen.net/assets/imagens/green-building-48px.png" alt="Gateway Icon" style="width: 24px;">`;
                }
              } else if (origem === "Ativo") {
                return `<img src="https://portal.taggen.net/assets/imagens/Beacon_48px.png" alt="Ativo Icon" style="width: 24px;">`;
              } else {
                return "";
              }
            },
            hozAlign: "center",
            headerSort: false,
            frozen: true,
            width: 75,
          },
          {
            title: "",
            field: "Status",
            formatter: function (cell, f) {
              var data = cell.getData();

              var cor = data.Cor;

              var status =
                '<i class="ui large icon info circle" style="color:' +
                cor +
                '; padding: 2px"></i>';

              switch (data.Status) {
                case "Atenção":
                  status =
                    '<i class="ui large icon exclamation circle" style="color:' +
                    cor +
                    '; padding: 2px"></i>';
                  break;
                case "Baixo":
                  status =
                    '<i class="ui large icon exclamation triangle" style="color:' +
                    cor +
                    '; padding: 2px"></i>';
                  break;
                case "Médio":
                  status =
                    '<i class="ui large icon exclamation triangle" style="color:' +
                    cor +
                    '; padding: 2px"></i>';
                  break;
                case "Alto":
                  status =
                    '<i class="ui large icon exclamation triangle" style="color:' +
                    cor +
                    '; padding: 2px"></i>';
                  break;
                case "Crítico":
                  status =
                    '<i class="ui large icon exclamation triangle" style="color:' +
                    cor +
                    '; padding: 2px"></i>';
                  break;
              }

              return status;
            },
            frozen: true,
            hozAlign: "center",
            resizable: false,
            headerSort: false,
            tooltip: function (e, cell, onRendered) {
              var data = cell.getData();

              return `Nivel: ${data.Status}`;
            },
            width: 75,
          },
          {
            title: "",
            field: "Alerta",
            headerFilter: "list",
            width: 200,
            headerFilterParams: {
              values: {
                "Ativos sem leitura": "Ativos sem leitura",
                "Gateway sem comunicação": "Gateway sem comunicação",
              },
              multiselect: true,
              clearable: true,
              sort: "asc",
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
            formatter: (cell: any) => {
              const value = cell.getValue();
              if (value === "Ativos sem leitura") {
                return ' Ativos sem leitura';
              } else if (value === "Gateway sem comunicação") {
                return ' Gateway sem comunicação';
              }
              return value || "-";
            },
          },
          {
            title: "Organização",
            field: "Organization",
            sorter: "string",
            headerFilter: "list",
            width: 200,
            headerFilterParams: {
              values: Array.from(
                new Set(visaoGeral.map((item) => item.Organization))
              ),
              multiselect: true,
            },
            headerFilterFunc: function (headerValue, rowValue) {
              if (headerValue.length === 0) {
                return true;
              }
              return headerValue.includes(rowValue);
            },
          },
          {
            title: "Local",
            field: "Local",
            sorter: "string",
            width: 200,
            headerFilter: "list",
            headerFilterParams: {
              values: [],
              multiselect: true,
              clearable: true,
              sort: "asc"
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
          },
          {
            title: "Descrição do Local",
            field: "LocalDescricao",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
              values: [],
              multiselect: true,
              clearable: true,
              sort: "asc"
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
          },
          {
            title: "Ativo/Gateway",
            field: "Origem",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
              values: {
                gateway: "Gateway",
                Ativo: "Ativo",
              },
              multiselect: true,
            },
            headerFilterFunc: function (headerValue, rowValue) {
              if (headerValue.length === 0) {
                return true;
              }
              // Normaliza o valor da linha para minúsculas para comparação
              const normalizedRowValue = rowValue?.toLowerCase();
              // Verifica se algum dos valores selecionados corresponde
              return headerValue.some((value: string) =>
                value.toLowerCase() === normalizedRowValue ||
                (value.toLowerCase() === "gateway" && normalizedRowValue === "gateway")
              );
            },
            formatter: function (cell, f) {
              var data = cell.getValue();
              // Normaliza a exibição do Gateway
              if (data?.toLowerCase() === "gateway") {
                return `<span><i class="ui hdd outline icon" style="padding-right: 3px"></i>Gateway</span>`;
              } else {
                return `<span><i class="ui tag icon" style="padding-right: 3px"></i>${data}</span>`;
              }
            },
          },
          {
            title: "Interações",
            field: "TotalInteracoes",
            sorter: "string",
            headerFilter: interationFilterEditor,
            headerFilterFunc: interationFilterFunction,
            formatter: function (cell, f) {
              var data = cell.getData();
              var organizacao = data.Organization;
              var id = data.IdWorkFlow;
              var interacoes = data.TotalInteracoes;

              if (data.Origem === "gateway") {
                return `<a href="/chamado-gateway?var-IdWorkFlow=${id}" style="display: flex; align-items: center; justify-content: center; gap: 5px;"><i class="ui icon external alternate"></i><i class="ui icon comments outline" style="color: gold;"></i><strong>${interacoes}</strong></a>`;
              } else {
                return `<a href="/chamado-ativo?var-IdWorkFlow=${id}" style="display: flex; align-items: center; justify-content: center; gap: 5px;"><i class="ui icon external alternate"></i><i class="ui icon comments outline" style="color: gold;"></i><strong>${interacoes}</strong></a>`
              }
            },
            hozAlign: "center",
            resizable: false,
            headerSort: false,
            tooltip: "Interações",
            width: 130,
          },
          {
            field: "Nome",
            title: "Nome Ativo/Gateway",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
              values: [],
              multiselect: true,
              clearable: true,
              sort: "asc"
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
            formatter: function (cell, f) {
              const data = cell.getData();
              var icone = data.Movel ? "car" : "building";
              if (data.Origem === "gateway") {
                var linkLocal = `/detalhes-do-gateway?gateway=${data.Nome}`;
                return `<a href="${linkLocal}"><i class="ui icon external alternate" style="padding-right: 5px"></i><i class="ui ${icone} icon" style="padding-right: 3px"></i>${data.Nome}</a>`;
              } else {
                var linkAtivo = `/detalhes-do-ativo?ativo=${data.Nome}`;
                return `<a href="${linkAtivo}"><i class="ui icon external alternate"></i>${data.Nome}</a>`;
              }
            },
            tooltip: function (e, cell, onRendered) {
              var data = cell.getData();
              return data.Movel ? `Gateway Móvel` : `Gateway Fixo`;
            },
          },
          {
            field: "Descricao",
            title: "Descrição Ativo/Gateway",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
              values: [],
              multiselect: true,
              clearable: true,
              sort: "asc"
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
            formatter: function (cell, f) {
              return isEmpty(cell.getValue())
                ? '<div style="margin: auto; width: 60%; text-align: center;">-</div>'
                : cell.getValue();
            },
          },
          {
            field: "Chamado",
            title: "Chamado",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
              values: [],
              multiselect: true,
              clearable: true,
              sort: "asc",
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
            frozen: false,
            formatter: function (cell, formatterParams, onRendered) {
              const chamado = cell.getValue();
              return chamado == null
                ? '<div style="margin: auto; width: 60%; text-align: center;">-</div>'
                : chamado;
            },
          },
          {
            title: "Ultima Interação",
            field: "UltimaInteracao",
            headerFilter: dateEditor,
            headerFilterFunc: dateFilterFunction,
            sorter: (a: string, b: string) => {
              const toTimestamp = (dateTimeStr: string) => {
                const match = dateTimeStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
                if (match) {
                  const [_, day, month, year, hours, mins, secs] = match;
                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    parseInt(hours),
                    parseInt(mins),
                    parseInt(secs)
                  ).getTime();
                }

                // Tenta formato ISO
                const isoDate = new Date(dateTimeStr);
                return isNaN(isoDate.getTime()) ? 0 : isoDate.getTime();
              };

              const timeA = a ? toTimestamp(a) : 0;
              const timeB = b ? toTimestamp(b) : 0;
              return timeA - timeB;
            },
            formatter: (cell: any) => {
              const value = cell.getValue();
              if (!value) return " - ";

              if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                return value;
              }

              const date = moment(value);
              return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "N/A";
            },
          },
          {
            field: "UltimoComentarioUsuario",
            title: "Comentado por...",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
              values: [],
              multiselect: true,
              clearable: true,
              sort: "asc"
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
          },
          {
            field: "Assunto",
            title: "Assunto",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
              values: [],
              multiselect: true,
              clearable: true,
              sort: "asc"
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
          },
          {
            field: "Requisitante",
            title: "Criado por",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
              values: [],
              multiselect: true,
              clearable: true,
              sort: "asc"
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
          },
          {
            field: "Responsavel",
            title: "Responsável",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
              values: [],
              multiselect: true,
              clearable: true,
              sort: "asc"
            },
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || headerValue.length === 0) return true;
              if (Array.isArray(headerValue)) {
                return headerValue.includes(rowValue);
              }
              return headerValue === rowValue;
            },
            headerFilterPlaceholder: "Selecione...",
          },
          {
            title: "Ultima Atualização",
            field: "UltimaAtualizacao",
            headerFilter: dateEditor,
            headerFilterFunc: dateFilterFunction,
            sorter: (a: string, b: string) => {
              const toTimestamp = (dateTimeStr: string) => {
                const match = dateTimeStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
                if (match) {
                  const [_, day, month, year, hours, mins, secs] = match;
                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    parseInt(hours),
                    parseInt(mins),
                    parseInt(secs)
                  ).getTime();
                }

                // Tenta formato ISO
                const isoDate = new Date(dateTimeStr);
                return isNaN(isoDate.getTime()) ? 0 : isoDate.getTime();
              };

              const timeA = a ? toTimestamp(a) : 0;
              const timeB = b ? toTimestamp(b) : 0;
              return timeA - timeB;
            },
            formatter: (cell: any) => {
              const value = cell.getValue();
              if (!value) return " - ";

              if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                return value;
              }

              const date = moment(value);
              return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "N/A";
            },
          },
          {
            title: "inclusão",
            field: "Inclusao",
            headerFilter: dateEditor,
            headerFilterFunc: dateFilterFunction,
            sorter: (a: string, b: string) => {
              const toTimestamp = (dateTimeStr: string) => {
                const match = dateTimeStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
                if (match) {
                  const [_, day, month, year, hours, mins, secs] = match;
                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    parseInt(hours),
                    parseInt(mins),
                    parseInt(secs)
                  ).getTime();
                }

                // Tenta formato ISO
                const isoDate = new Date(dateTimeStr);
                return isNaN(isoDate.getTime()) ? 0 : isoDate.getTime();
              };

              const timeA = a ? toTimestamp(a) : 0;
              const timeB = b ? toTimestamp(b) : 0;
              return timeA - timeB;
            },
            formatter: (cell: any) => {
              const value = cell.getValue();
              if (!value) return " - ";

              if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                return value;
              }

              const date = moment(value);
              return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "N/A";
            },
          },
          { field: "Fechamento", title: "Fechamento", sorter: "number" },
          {
            title: "Tempo decorrido",
            field: "TempoDecorrido",
            headerFilter: durationFilterEditor,
            headerFilterFunc: (headerValue: any, rowValue: any) => {
              if (!headerValue || !headerValue.start) return true;

              const minutes = parseInt(rowValue);
              if (isNaN(minutes)) return false;

              let compareValue = minutes;
              if (headerValue.unit === "horas") {
                compareValue = minutes / 60;
              } else if (headerValue.unit === "dias") {
                compareValue = minutes / (60 * 24);
              }
              else if (headerValue.unit === "meses") {
                compareValue = minutes / (60 * 24 * 30);
              }

              const start = parseFloat(headerValue.start);
              const end = parseFloat(headerValue.end);

              if (!isNaN(start) && !isNaN(end)) {
                return compareValue >= start && compareValue <= end;
              } else if (!isNaN(start)) {
                return compareValue >= start;
              } else if (!isNaN(end)) {
                return compareValue <= end;
              }
              return true;
            },
            formatter: (cell: any) => deltaTime(cell.getValue()),
          },
        ],
        initialSort: [
          { column: "Situacao", dir: "asc" },]
      });

      mainTableRef.current.on("rowClick", function (e: any, row: any) {
        // Remove a classe 'selected' de todas as linhas
        const rows = mainTableRef.current.getRows();
        rows.forEach((r: any) => r.getElement().classList.remove("selected"));

        // Adiciona a classe 'selected' à linha clicada
        row.getElement().classList.add("selected");
      });

      // Evento dataLoaded para atualizar as opções dos filtros
      mainTableRef.current.on("dataLoaded", function (data: IVisaoGeralModel[]) {
        if (data.length > 0) {
          // Extrai valores únicos para cada coluna que usa filtro de lista
          const uniqueLocais = Array.from(new Set(data.map((item: IVisaoGeralModel) => item.Local)))
            .filter(Boolean)
            .sort();

          const uniqueLocalDescricoes = Array.from(new Set(data.map((item: IVisaoGeralModel) => item.LocalDescricao)))
            .filter(Boolean)
            .sort();

          const uniqueNomes = Array.from(new Set(data.map((item: IVisaoGeralModel) => item.Nome)))
            .filter(Boolean)
            .sort();

          const uniqueDescricoes = Array.from(new Set(data.map((item: IVisaoGeralModel) => item.Descricao)))
            .filter(Boolean)
            .sort();

          const uniqueChamados = Array.from(new Set(data.map((item: IVisaoGeralModel) => item.Chamado)))
            .filter(Boolean)
            .sort();

          const uniqueComentadores = Array.from(new Set(data.map((item: IVisaoGeralModel) => item.UltimoComentarioUsuario)))
            .filter(Boolean)
            .sort();

          const uniqueAssuntos = Array.from(new Set(data.map((item: IVisaoGeralModel) => item.Assunto)))
            .filter(Boolean)
            .sort();

          const uniqueRequisitantes = Array.from(new Set(data.map((item: IVisaoGeralModel) => item.Requisitante)))
            .filter(Boolean)
            .sort();

          const uniqueResponsaveis = Array.from(new Set(data.map((item: IVisaoGeralModel) => item.Responsavel)))
            .filter(Boolean)
            .sort();

          // Também atualizar as opções da coluna Organização para manter consistente
          const uniqueOrganizacoes = Array.from(new Set(data.map((item: IVisaoGeralModel) => item.Organization)))
            .filter(Boolean)
            .sort();

          // Atualiza as opções de filtro para cada coluna
          mainTableRef.current.updateColumnDefinition("Organization", {
            headerFilterParams: {
              values: uniqueOrganizacoes,
              multiselect: true,
              clearable: true,
            },
          });

          mainTableRef.current.updateColumnDefinition("Local", {
            headerFilterParams: {
              values: uniqueLocais,
              multiselect: true,
              clearable: true,
            },
          });

          mainTableRef.current.updateColumnDefinition("LocalDescricao", {
            headerFilterParams: {
              values: uniqueLocalDescricoes,
              multiselect: true,
              clearable: true,
            },
          });

          mainTableRef.current.updateColumnDefinition("Nome", {
            headerFilterParams: {
              values: uniqueNomes,
              multiselect: true,
              clearable: true,
            },
          });

          mainTableRef.current.updateColumnDefinition("Descricao", {
            headerFilterParams: {
              values: uniqueDescricoes,
              multiselect: true,
              clearable: true,
            },
          });

          mainTableRef.current.updateColumnDefinition("Chamado", {
            headerFilterParams: {
              values: uniqueChamados,
              multiselect: true,
              clearable: true,
            },
          });

          mainTableRef.current.updateColumnDefinition("UltimoComentarioUsuario", {
            headerFilterParams: {
              values: uniqueComentadores,
              multiselect: true,
              clearable: true,
            },
          });

          mainTableRef.current.updateColumnDefinition("Assunto", {
            headerFilterParams: {
              values: uniqueAssuntos,
              multiselect: true,
              clearable: true,
            },
          });

          mainTableRef.current.updateColumnDefinition("Requisitante", {
            headerFilterParams: {
              values: uniqueRequisitantes,
              multiselect: true,
              clearable: true,
            },
          });

          mainTableRef.current.updateColumnDefinition("Responsavel", {
            headerFilterParams: {
              values: uniqueResponsaveis,
              multiselect: true,
              clearable: true,
            },
          });
        }
      });

      // Função para atualizar o footerElement
      const updateFooter = (totalRows: number, filteredRows: number) => {
        const footer = document.getElementById("footer");
        if (footer) {
          footer.innerHTML = `${totalRows} linhas retornadas (linhas filtradas: ${filteredRows})`;
        }
      };

      // Adicione o evento dataFiltered
      mainTableRef.current.on(
        "dataFiltered",
        function (filters: any, rows: any[]) {
          updateFooter(visaoGeral.length, rows.length);
        }
      );

      // Observador de mutações para garantir que o footerElement seja atualizado corretamente
      const observer = new MutationObserver(() => {
        updateFooter(visaoGeral.length, 0);
      });

      const footer = document.getElementById("footer");
      if (footer) {
        observer.observe(footer, { childList: true });
      }

      // Adicionar evento para salvar filtros quando alterados
      mainTableRef.current.on("headerFilterChanged", function (_headerValue: any, _field: string) {
        const allFilters = mainTableRef.current.getHeaderFilters() as TableFilter[];
        const filtersObject = allFilters.reduce((acc: Record<string, any>, filter: TableFilter) => {
          acc[filter.field] = filter.value;
          return acc;
        }, {});

        // Incluir organizações selecionadas
        filtersObject.selectedOrganizations = selectedOrganizations;

        setActiveFilters(filtersObject);
        saveFiltersToStorage(filtersObject);
      });

      // Só aplica os filtros salvos se não for refresh
      if (shouldApplyFilters) {
        applyStoredFilters();
      }

      // Limpeza do observador quando o componente é desmontado
      return () => {
        if (observer) {
          observer.disconnect();
        }
      };
    }
  }, [visaoGeral]);

  // Adicionar useEffect para monitorar mudanças nas organizações selecionadas
  useEffect(() => {
    if (selectedOrganizations.length > 0) {
      const currentFilters = loadFiltersFromStorage() || {};
      saveFiltersToStorage({
        ...currentFilters,
        selectedOrganizations: selectedOrganizations
      });
    }
  }, [selectedOrganizations]);

  const [filteredData, setFilteredData] = useState(visaoGeral);
  const [selectedOrganization, setSelectedOrganization] = useState<
    string | null
  >(null);

  const handleFilterChange = (filterType: string, selectedOption: any) => {
    if (filterType === "Organization") {
      setSelectedOrganization(selectedOption ? selectedOption.value : null);
    }

    let filtered = visaoGeral;

    if (selectedOption) {
      if (filterType === "Organization") {
        filtered = filtered.filter(
          (alert) => alert.Organization === selectedOption.value
        );
      }
    }
    setFilteredData(filtered);
    console.log(filtered);
  };

  useEffect(() => {
    if (mainTableRef.current) {
      mainTableRef.current.replaceData(visaoGeral);
    }
  }, [visaoGeral]);

  const Organizations = Array.from(
    new Set(visaoGeral.map((item) => item.Organization))
  );

  const handleSettingsClick = () => {
    setSidebarVisible(!sidebarVisible);
    if (!sidebarVisible) {
      setTimeout(loadConfigTable, 300);
    }
  };

  const handleDownloadCsv = () => {
    if (mainTableRef.current) {
      mainTableRef.current.download("csv", "Visãogeral.csv");
    }
  };
  useEffect(() => {
    const filteredRowCount = mainTableRef.current.getData(true).length;
    setFilteredRowCount(filteredRowCount);
  }, [filteredData]);

  const applyConfigChanges = () => {
    const updatedCols = configTableRefInstance.current.getData();

    // Pega todas as colunas da tabela principal
    const allColumns = mainTableRef.current.getColumns();

    // Garante que as 3 primeiras colunas estejam sempre nas primeiras posições
    const frozenColumns = allColumns
      .slice(0, 3)
      .map((col: ColumnComponent) => col.getDefinition()); // Pegando as definições das 3 primeiras colunas

    // Atualiza as colunas restantes, sem alterar as 3 primeiras
    const newColumns = updatedCols
      .map((col: any) => {
        const originalCol = mainTableRef.current.getColumn(col.field);
        if (originalCol) {
          const definition = originalCol.getDefinition();
          return {
            ...definition,
            visible: col.visible,
          };
        }
        obterVisaoGeral();
        return col;
      })
      .slice(3); // Remove as 3 primeiras colunas da lista de atualizações

    const finalColumns = [...frozenColumns, ...newColumns];

    // Atualiza as colunas da tabela principal
    mainTableRef.current.setColumns(finalColumns);
  };

  return (
    <div className="d-flex" style={{ position: "relative" }}>
      <div
        style={{ width: sidebarVisible ? "80%" : "100%", transition: "0.3s" }}
      >
        <h1 className="ui header">Visão Geral</h1>
        <div
          style={{
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {/* Filtro de Corporações */}
          <div style={{ flex: 1, maxWidth: "300px" }}>
            <Select
              options={availableCorporations.map((corp) => ({
                label: corp.name,
                value: corp.id,
              }))}
              onChange={(selectedOption: any) => {
                const corpId = selectedOption ? selectedOption.value : null;
                setSelectedCorporation(corpId);

                // Filtrar organizações baseado na corporação selecionada
                if (corpId) {
                  const filteredOrgs = availableOrganizations
                    .filter(org => org.Idcorporacao === corpId)
                    .map(org => org.OrganizationName);
                  setSelectedOrganizations(filteredOrgs);
                  aplicarFiltroOrganizacoes(filteredOrgs);
                } else {
                  setSelectedOrganizations([]);
                  aplicarFiltroOrganizacoes([]);
                }
              }}
              placeholder="Filtrar por Corporação"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
          {/* Filtro de Organizações */}
          <div style={{ flex: 1, maxWidth: "300px" }}>
            <Select
              isMulti
              options={availableOrganizations
                .filter(org => !selectedCorporation || org.Idcorporacao === selectedCorporation)
                .map((org) => ({
                  label: org.OrganizationName,
                  value: org.OrganizationName,
                }))}
              onChange={(selectedOptions: any) => {
                const selectedOrgs = selectedOptions
                  ? selectedOptions.map((opt: any) => opt.value)
                  : [];
                setSelectedOrganizations(selectedOrgs);
                aplicarFiltroOrganizacoes(selectedOrgs);
              }}
              value={selectedOrganizations.map(org => ({
                label: org,
                value: org,
              }))}
              placeholder="Filtrar por Organização"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
          {/* Botão de Configurações */}
          <button onClick={handleSettingsClick} className="button primary">
            ⚙️ Configurações
          </button>
          {/* Botão para Limpar Filtros */}
          <button
            onClick={limparFiltros}
            style={{ padding: "10px 20px", cursor: "pointer" }}
            className="button secondary"
          >
            🗑️ Limpar Filtros
          </button>
          {/* Botão de Download CSV */}
          <button
            className="button secondary"
            onClick={handleDownloadCsv}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <i className="ui icon arrow alternate circle down outline"></i>
            Download CSV
          </button>
          {/* Botão de Atualizar */}
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            className="button secondary"
          >
            <i className="ui icon refresh"></i>
            Atualizar
          </button>
        </div>
        {/* Tabela */}
        <div ref={tableRef}></div>
      </div>
      {/* Sidebar de Configurações */}
      {sidebarVisible && (
  <div className="sidebar-config">
    
    {/* Botão de Fechar (X) com classe CSS */}
    <i 
      className="ui icon close sidebar-close-btn" 
      onClick={() => setSidebarVisible(false)}
      title="Fechar configurações"
    />

    {/* Header ajustado: Removido 'inverted' para controlar via CSS */}
    <h4 className="ui grey header sidebar-header">
      <i className="ui cog icon"></i> Configurações da Tabela
    </h4>

    <div className="config-content" ref={configTableRef}></div>
    
    <button className="ui primary button" onClick={applyConfigChanges}>
      <i className="ui save icon"></i> Aplicar
    </button>
  </div>
)}
    </div>
  );
};

export default MenuAlertTestPage;
